export enum UserTypes {
    GlobalAdmin = "GlobalAdmin",
    SuperAdmin = "SuperAdmin",
    ReferralLead = "ReferralLead",
    ReferralCoordinator = "ReferralCoordinator",
    RecoveryLead = "RecoveryLead",
    RecoveryCoordinator = "RecoveryCoordinator",
    LabLead = "LabLead",
    LabCoordinator = "LabCoordinator",
    MedicalChartLead = "MedicalChartLead",
    MedicalChartCoordinator = "MedicalChartCoordinator",
    DistributionLead = "DistributionLead",
    DistributionCoordinator = "DistributionCoordinator",
    ProcessingLead = "ProcessingLead",
    ProcessingCoordinator = "ProcessingCoordinator",
    QualityAssuranceLead = "QualityAssuranceLead",
    QualityAssuranceCoordinator = "QualityAssuranceCoordinator",
    Invoicing = "Invoicing",
    CEBT = "CEBT",
    Biobank = "Biobank",
    SurgeryScheduler = "SurgeryScheduler",
    Surgeon = "Surgeon",
    User = "User",
    Guest = "Guest",
}

export const LeadRoles = [
    UserTypes.ReferralLead,
    UserTypes.RecoveryLead,
    UserTypes.LabLead,
    UserTypes.MedicalChartLead,
    UserTypes.DistributionLead,
    UserTypes.ProcessingLead,
    UserTypes.QualityAssuranceLead,
    UserTypes.Invoicing,
    UserTypes.CEBT,
    UserTypes.Biobank,
    UserTypes.SurgeryScheduler,
    UserTypes.Surgeon,
];

export const CoordinatorRoles = [
    UserTypes.ReferralCoordinator,
    UserTypes.RecoveryCoordinator,
    UserTypes.LabCoordinator,
    UserTypes.MedicalChartCoordinator,
    UserTypes.DistributionCoordinator,
    UserTypes.ProcessingCoordinator,
    UserTypes.QualityAssuranceCoordinator,
];
